module.exports = require('./modules/components/Link');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/Link.js
// module id = 188
// module chunks = 0